export interface NotificationSettings {
  muted_media_ids: number[];
  new_campaign_started: boolean;
  campaign_paused: boolean;
  campaign_reactivated: boolean;
  commission_changed: boolean;
  deals_and_vouchers: boolean;
}

export interface NotificationType {
  id: string;
  name: string;
  permission: [string];
}

export const newCampaignStarted: NotificationType = {
    id: 'new_campaign_started',
    name: 'New campaign started',
    permission: ['Publisher'],
};

export const adSpaceAccepted: NotificationType = {
  id: 'adspace_accepted',
  name: 'AdSpace accepted',
  permission: ['Publisher'],
};

export const campaignPaused: NotificationType = {
  id: 'campaign_paused',
  name: 'Campaign paused',
  permission: ['Publisher'],
};

export const campaignReactivated: NotificationType = {
  id: 'campaign_reactivated',
  name: 'Campaign reactivated',
  permission: ['Publisher'],
};

export const commissionChanged: NotificationType = {
  id: 'commission_changed',
  name: 'Payout changed',
  permission: ['Publisher'],
};

export const dealsAndVouchers: NotificationType = {
  id: 'deals_and_vouchers',
  name: 'New Deals and Vouchers',
  permission: ['Publisher'],
};

export const banners: NotificationType = {
  id: 'banners',
  name: 'New Banners',
  permission: ['Publisher'],
};

export const notifications: NotificationType[] = [
  newCampaignStarted,
  adSpaceAccepted,
  campaignPaused,
  campaignReactivated,
  commissionChanged,
  dealsAndVouchers,
  banners,
];
